import { render, staticRenderFns } from "./zhiyexiangqing.vue?vue&type=template&id=3d743628&scoped=true"
import script from "./zhiyexiangqing.vue?vue&type=script&lang=js"
export * from "./zhiyexiangqing.vue?vue&type=script&lang=js"
import style0 from "./zhiyexiangqing.vue?vue&type=style&index=0&id=3d743628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d743628",
  null
  
)

export default component.exports